import { Dashboard } from "@mui/icons-material";
import { create } from "zustand";
import { persist } from "zustand/middleware";

const useStore = create(
  persist(
    (set) => ({
      isAgentUpdate: false,
      setIsAgentUpdate: (value) => set({ isAgentUpdate: value }),
      isLoanSubmit: false,
      setLoanSubmit: (value) => set({ isLoanSubmit: value }),
      isUpdate: false,
      setIsUpdate: (value) => set({ isUpdate: value }),
      isPermissionUpdate: false,
      setIsPermissionUpdate: (value) => set({ isPermissionUpdate: value }),
      permissionid: "",
      setPermissionsId: (value) => set({ permissionid: value }),
      editUserId: "",
      setEditUserId: (value) => set({ editUserId: value }),
      permissions: [],
      setPermissions: (permissions) => set({ permissions: permissions }),
      accountHistory: [],
      setAccountHistory: (accountHistory) =>
        set({ accountHistory: accountHistory }),
      balance: "",
      setBalance: (balance) => set({ balance: balance }),
      pigmyId: "",
      setPigmyId: (id) => set({ pigmyId: id }),
      loanId: "",
      setLoanId: (id) => set({ loanId: id }),
      dashboardDetails: {},
      setDashboardDetails: (details) => set({ dashboardDetails: details }),
      permissionData: null,
      setPermissionsData: (value) =>
        set({
          permissionData: value,
        }),
      settings: {},
      setSettings: (value) => set({ settings: value }),
    }),
    {
      name: "adminStore", // unique name for your store
      getStorage: () => sessionStorage, // specify sessionStorage as the storage
    }
  )
);

export default useStore;
